import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import { formatDate, headerCell } from "../format";

const columns = [
  { id: "username", label: "Username" },
  { id: "email", label: "Email" },
  { id: "createdAt", label: "Created on", align: "center" },
  { id: "latestOrderOn", label: "Latest order on", align: "center" },
];

const CustomersTable = ({
  rows,
  sortBy,
  sortDir,
  onSort,
  onOpenCustomer,
  onOpenTab,
  onClarity,
}) => {
  const [menu, setMenu] = useState({ anchor: null, row: null });

  const closeMenu = () => setMenu({ anchor: null, row: null });

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={col.id}
                  sx={[headerCell, { textAlign: col.align || "left" }]}
                >
                  <TableSortLabel
                    active={sortBy === col.id}
                    direction={
                      sortBy === col.id ? sortDir.toLowerCase() : "desc"
                    }
                    onClick={() => onSort(col.id)}
                  >
                    {col.label}
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell sx={headerCell} align="center">
                Clarity
              </TableCell>
              <TableCell sx={headerCell} align="right">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={6}
                  align="center"
                  sx={{ py: 6, color: "#6b7280" }}
                >
                  No customers found.
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <TableRow
                  key={row.id}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() => onOpenCustomer(row.id)}
                >
                  <TableCell sx={{ color: "#111827", fontWeight: 500 }}>
                    {row.username || "—"}
                  </TableCell>
                  <TableCell sx={{ color: "#111827" }}>{row.email}</TableCell>
                  <TableCell sx={{ color: "#6b7280" }} align="center">
                    {formatDate(row.createdAt)}
                  </TableCell>
                  <TableCell sx={{ color: "#6b7280" }} align="center">
                    {formatDate(row.latestOrderOn)}
                  </TableCell>
                  <TableCell
                    align="center"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Tooltip title="View in Clarity">
                      <IconButton
                        size="small"
                        onClick={() => onClarity(row.email)}
                        sx={{ color: "#2563eb" }}
                      >
                        <AnalyticsOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                    <IconButton
                      size="small"
                      onClick={(e) => setMenu({ anchor: e.currentTarget, row })}
                    >
                      <MoreHorizIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Menu
        anchorEl={menu.anchor}
        open={Boolean(menu.anchor)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            onOpenCustomer(menu.row?.id);
            closeMenu();
          }}
        >
          View
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenTab(menu.row?.id, "orders");
            closeMenu();
          }}
        >
          Orders
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenTab(menu.row?.id, "unlocks");
            closeMenu();
          }}
        >
          Unlock history
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenTab(menu.row?.id, "credits");
            closeMenu();
          }}
        >
          Credit history
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenTab(menu.row?.id, "credit-purchases");
            closeMenu();
          }}
        >
          Credit purchases
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenTab(menu.row?.id, "product-purchases");
            closeMenu();
          }}
        >
          Product purchases
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenTab(menu.row?.id, "utm");
            closeMenu();
          }}
        >
          UTM info
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClarity(menu.row?.email);
            closeMenu();
          }}
        >
          View in Clarity
        </MenuItem>
      </Menu>
    </>
  );
};

export default CustomersTable;
